module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"geothermalTitle":"Zulässigkeit Wärmenutzung","ewsAdmissibility":"Erdwärmesonden","gwAdmissibility":"Grundwasser","ambiguousMessage":"(Nicht eindeutig, zur Sicherheit manuell überprüfen)"}}')
  delete Component.options._Ctor
}
